export default __webpack_public_path__ + "static/media/Inter-ExtraBold.00e1fde4.woff";